import { render, staticRenderFns } from "./common-access-settlement-info.vue?vue&type=template&id=6bcc0ec1&"
import script from "./common-access-settlement-info.vue?vue&type=script&lang=js&"
export * from "./common-access-settlement-info.vue?vue&type=script&lang=js&"
import style0 from "./common-access-settlement-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports